<section class="mx-3">
    <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
            <div>
                <button mat-icon-button class="back_icon me-2" (click)="backPage()">
                    <i class="fa-solid fa-arrow-left"></i>
                </button>
            </div>
            <div class="page_header">
                <h3 translate class="m-0 page_header_title">Academic Semisters List</h3>
            </div>
        </div>
        <div *ngIf="actiondata?.create">
            <button translate mat-raised-button color="primary" (click)="openCreateSemisterDialog()"
                class="px-5 add_button">Add</button>
        </div>
    </div>
    <div class="position-relative">
        <div class="mt-2 table-container" *ngIf="actiondata?.list_view">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <!-- <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef> Sl.no </th>
              <td mat-cell *matCellDef="let element"> {{ element.id }} </td>
            </ng-container> -->
                <ng-container matColumnDef="academic_year">
                    <th translate mat-header-cell *matHeaderCellDef>Academic Year</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.start_date | date : "YYYY" }} -
                        {{ element.end_date | date : "YYYY" }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="semister">
                    <th translate mat-header-cell *matHeaderCellDef>Semister</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.semister }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="course_name">
                    <th translate mat-header-cell *matHeaderCellDef>Course Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.course_name }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th translate mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let row">
                        <p translate class="m-0 cursor_pointer" (click)="gotopromotestudents(row)">
                            View
                        </p>
                        <!-- <button mat-button class="update_button" color="primary">
                            Edit
                        </button>
                        <button mat-button color="warn" class="delete_button">
                            Delete
                        </button> -->
                    </td>
                </ng-container>

                <!-- Define Header and Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td translate class="mat-cell" colspan="4">No data</td>
                </tr>
            </table>
        </div>
        <div class="mt-2" *ngIf="total_count > 5">
            <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
        </div>
    </div>
    <div>
        <ng-template #createSemesterDialog let-dialogRef>
            <div class="">
                <div class="dialog-header">
                    <h3 translate mat-dialog-title class="m-0 px-2">Add Semesters</h3>
                    <button mat-icon-button mat-dialog-close (click)="onSaveClick()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <div mat-dialog-content class="dialog-content">
                    <form [formGroup]="createsemisterForm" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <div *ngFor="let question of createsemister" class="form-group mb-2 col-md-6 col-sm-6">
                                <app-question [question]="question" [form]="createsemisterForm"></app-question>
                            </div>
                        </div>
                    </form>
                </div>
                <div mat-dialog-actions class="dialog-actions">
                    <button translate mat-stroked-button mat-dialog-close color="warn" class="cancel_button mx-2"
                        (click)="onSaveClick()">
                        Cancel
                    </button>
                    <button translate mat-button color="primary" [disabled]="!createsemisterForm.valid" class="submit_button px-2"
                        (click)="onSubmit()">
                        Submit
                    </button>
                </div>
            </div>
        </ng-template>
    </div>
</section>